import { bookingsStrings } from '@data/bookings';
import type { PageMeta } from '@utils/pages';

export const meta: PageMeta = {
  title: bookingsStrings.title().all,
  listed: true,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
  order: 2,
};
